"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerSizes = void 0;
exports.ContainerSizes = { comfortable: 10, cozy: 4, compact: 2 };
